module.exports = __webpack_public_path__ + "img/homePageImg08.18bebbe9.png";